import TranslatableTypography from "app/components/shared/TranslatableTypography";
import { makeColumnsResponsive } from "app/shared/utils";
import { Theme } from "common";

/**
 * History Table MUI Column configuration
 *
 * @see https://mui.com/x/react-data-grid/column-definition/
 */
export const getTableColumnHeaders = ({ t, csvType }) => {
  const tableColumns = [
    {
      field: "Context",
      renderHeader: () => (
        <TranslatableTypography tlEntry="csv.table.columnName.context" />
      ),
      sortable: false,

      width: 80,
      hide: csvType !== t(`csvTypes.participants`),
    },
    {
      field: "Protocol Number",
      renderHeader: () => (
        <TranslatableTypography tlEntry="csv.table.columnName.protocolNumber" />
      ),
      sortable: false,
      width: 130,
      hide: csvType !== t(`csvTypes.participants`),
    },
    {
      field: "Study Site",
      renderHeader: () => (
        <TranslatableTypography tlEntry="csv.table.columnName.studySite" />
      ),
      sortable: false,
      width: 160,
      hide: csvType !== t(`csvTypes.participants`),
    },
    {
      field: "MRN",
      renderHeader: () => (
        <TranslatableTypography tlEntry="csv.table.columnName.mrn" />
      ),
      sortable: false,
      width: 130,
      hide: csvType !== t(`csvTypes.participants`),
    },
    {
      field: "Race",
      renderHeader: () => (
        <TranslatableTypography tlEntry="csv.table.columnName.race" />
      ),
      sortable: false,
      width: 90,
      hide: csvType !== t(`csvTypes.participants`),
    },
    {
      field: "First Name",
      renderHeader: () => (
        <TranslatableTypography tlEntry="csv.table.columnName.firstName" />
      ),
      sortable: false,
      width: 120,
      hide: csvType !== t(`csvTypes.participants`),
    },
    {
      field: "Last Name",
      renderHeader: () => (
        <TranslatableTypography tlEntry="csv.table.columnName.lastName" />
      ),
      sortable: false,
      width: 120,
      hide: csvType !== t(`csvTypes.participants`),
    },
    {
      field: "Middle Name",
      renderHeader: () => (
        <TranslatableTypography tlEntry="csv.table.columnName.middleName" />
      ),
      sortable: false,
      width: 120,
      hide: csvType !== t(`csvTypes.participants`),
    },
    {
      field: "Suffix",
      renderHeader: () => (
        <TranslatableTypography tlEntry="csv.table.columnName.suffix" />
      ),
      sortable: false,
      width: 70,
      hide: csvType !== t(`csvTypes.participants`),
    },
    {
      field: "Birth Date",
      renderHeader: () => (
        <TranslatableTypography tlEntry="csv.table.columnName.birthDate" />
      ),
      sortable: false,
      width: 100,
      hide: csvType !== t(`csvTypes.participants`),
    },
    {
      field: "Gender",
      renderHeader: () => (
        <TranslatableTypography tlEntry="csv.table.columnName.gender" />
      ),
      sortable: false,
      width: 80,
      hide: csvType !== t(`csvTypes.participants`),
    },
    {
      field: "Ethnicity",
      renderHeader: () => (
        <TranslatableTypography tlEntry="csv.table.columnName.ethnicity" />
      ),
      sortable: false,
      width: 120,
      hide: csvType !== t(`csvTypes.participants`),
    },
    {
      field: "Approximate Birth Date Flag",
      renderHeader: () => (
        <TranslatableTypography tlEntry="csv.table.columnName.approximateBirthDateFlag" />
      ),
      sortable: false,
      width: 140,
      hide: csvType !== t(`csvTypes.participants`),
    },
    {
      field: "Birth Date Not Available Flag",
      renderHeader: () => (
        <TranslatableTypography tlEntry="csv.table.columnName.birthDateNotAvailableFlag" />
      ),
      sortable: false,
      width: 140,
      hide: csvType !== t(`csvTypes.participants`),
    },
    {
      field: "Approximate Expired Date Flag",
      renderHeader: () => (
        <TranslatableTypography tlEntry="csv.table.columnName.approximateExpiredDateFlag" />
      ),
      sortable: false,
      width: 140,
      hide: csvType !== t(`csvTypes.participants`),
    },
    {
      field: "Expired Date",
      renderHeader: () => (
        <TranslatableTypography tlEntry="csv.table.columnName.expiredDate" />
      ),
      sortable: false,
      width: 100,
      hide: csvType !== t(`csvTypes.participants`),
    },
    {
      field: "ZIP At Registration",
      renderHeader: () => (
        <TranslatableTypography tlEntry="csv.table.columnName.zipAtRegistration" />
      ),
      sortable: false,
      width: 100,
      hide: csvType !== t(`csvTypes.participants`),
    },

    {
      field: "Protocol No",
      renderHeader: () => (
        <TranslatableTypography tlEntry="csv.table.columnName.protocolNo" />
      ),
      sortable: false,
      width: 120,
      hide: csvType === t(`csvTypes.participants`),
    },
    {
      field: "Organizational Unit",
      renderHeader: () => (
        <TranslatableTypography tlEntry="csv.table.columnName.organizationalUnit" />
      ),
      sortable: false,
      width: 150,
      hide: csvType === t(`csvTypes.participants`),
    },
    {
      field: "Department",
      renderHeader: () => (
        <TranslatableTypography tlEntry="csv.table.columnName.department" />
      ),
      sortable: false,
      width: 100,
      hide: csvType === t(`csvTypes.participants`),
    },
    {
      field: "Library",
      renderHeader: () => (
        <TranslatableTypography tlEntry="csv.table.columnName.library" />
      ),
      sortable: false,
      width: 130,
      hide: csvType === t(`csvTypes.participants`),
    },
    {
      field: "IRB No",
      renderHeader: () => (
        <TranslatableTypography tlEntry="csv.table.columnName.irbNumber" />
      ),
      sortable: false,
      width: 105,
      hide: csvType === t(`csvTypes.participants`),
    },
    {
      field: "Title",
      renderHeader: () => (
        <TranslatableTypography tlEntry="csv.table.columnName.title" />
      ),
      sortable: false,
      width: 415,
      hide: csvType === t(`csvTypes.participants`),
    },
    {
      field: "Estimated Completion Date",
      renderHeader: () => (
        <TranslatableTypography tlEntry="csv.table.columnName.estimatedCompletionDate" />
      ),
      sortable: false,
      width: 200,
      hide: csvType === t(`csvTypes.participants`),
    },
    {
      field: "Involves Therapy",
      renderHeader: () => (
        <TranslatableTypography tlEntry="csv.table.columnName.involvesTherapy" />
      ),
      sortable: false,
      width: 130,
      hide: csvType === t(`csvTypes.participants`),
    },
    {
      field: "Summary Accrual Info Only",
      renderHeader: () => (
        <TranslatableTypography tlEntry="csv.table.columnName.summaryAccrualInfoOnly" />
      ),
      sortable: false,
      width: 210,
      hide: csvType === t(`csvTypes.participants`),
    },
    {
      field: "Protocol Type",
      renderHeader: () => (
        <TranslatableTypography tlEntry="csv.table.columnName.protocolType" />
      ),
      sortable: false,
      width: 170,
      hide: csvType === t(`csvTypes.participants`),
    },
    {
      field: "Management Group",
      renderHeader: () => (
        <TranslatableTypography tlEntry="csv.table.columnName.managementGroup" />
      ),
      sortable: false,
      width: 170,
      hide: csvType === t(`csvTypes.participants`),
    },
    {
      field: "StaffPd",
      renderHeader: () => (
        <TranslatableTypography tlEntry="csv.table.columnName.staffPd" />
      ),
      sortable: false,
      width: 70,
      hide: csvType === t(`csvTypes.participants`),
    },
    {
      field: "StaffPrimaryCRC",
      renderHeader: () => (
        <TranslatableTypography tlEntry="csv.table.columnName.staffPrimaryCrc" />
      ),
      sortable: false,
      width: 180,
      hide: csvType === t(`csvTypes.participants`),
    },
    {
      field: "InstitutionSites",
      renderHeader: () => (
        <TranslatableTypography tlEntry="csv.table.columnName.institutionSites" />
      ),
      sortable: false,
      width: 160,
      hide: csvType === t(`csvTypes.participants`),
    },
  ];

  // MUI thought it'd be a great idea to deprecate the 'hide' property.
  // The new columnVisibilityModel is overly complex for what we need &
  // more geared to user-interaction to show/hide a column:
  // @see https://mui.com/x/react-data-grid/column-visibility/#initialize-the-visible-columns
  return makeColumnsResponsive(tableColumns.filter((c) => !c.hide));
};

export const tableStyles = {
  boxShadow: 3,
  borderRadius: "8px",
  width: "100%",
  "& .MuiDataGrid-columnHeader": {
    "& .MuiDataGrid-columnHeaderTitle": {
      fontSize: "14px",
      fontWeight: 400,
    },
    "&:focus": {
      outline: "none !important",
    },
    "&:focus-within": {
      outline: "none !important",
    },
  },
  "& .MuiDataGrid-columnHeader--last .MuiDataGrid-columnSeparator": {
    display: "none",
  },
  "& .MuiDataGrid-columnSeparator": {
    visibility: "visible",
  },
  "& .MuiDataGrid-cell": {
    fontSize: "14px",
    display: "flex",
    alignItems: "center",
    whiteSpace: "normal",
    wordWrap: "break-word",
    "&:focus": {
      outline: "none !important",
    },
    "&:focus-within": {
      outline: "none !important",
    },
  },
  "& .MuiTablePagination-root": {
    "& .MuiTablePagination-selectLabel": {
      fontSize: "14px",
    },
    "& .MuiTablePagination-displayedRows": {
      fontSize: "14px",
    },
    fontSize: "14px",
  },
  "&& .MuiIconButton-root": {
    width: "1em",
    height: "1em",
  },
  "& .Mui-odd": {
    backgroundColor: "#F0F4F5",
    "&:hover": {
      backgroundColor: "#F0F4F5",
    },
  },
  "& .Mui-even": {
    "&:hover": {
      backgroundColor: Theme.palette.primary.contrastText,
    },
  },
  "& .MuiCheckbox-root": {
    padding: "0px",
  },
  "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
    minHeight: "52px !important",
    padding: "5px 10px",
  },
  "& .MuiDataGrid-columnHeaderCheckbox": {
    minWidth: "30px !important",
    width: "30px !important",
    "& .MuiDataGrid-columnSeparator": {
      display: "none",
    },
  },
  "& .MuiDataGrid-cellCheckbox": {
    minWidth: "30px !important",
    width: "30px !important",
    padding: "0px !important",
  },
};
